<script lang="ts">
  export let label = '';
  export let placeholder = '';
  export let value: number | null;
  export let step: number | undefined = undefined;
  export let min: number | undefined = undefined;
  export let max: number | undefined = undefined;
  export let id = '';
  export let required = false;
</script>

<style lang="postcss">
  .container {
    display: grid;
    gap: 0.25rem;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .container {
      grid-template-columns: 1fr 2fr 1fr;
      align-items: start;
      gap: 1.5rem;
    }

    .container > div:first-child {
      display: flex;
      align-items: center;
      justify-content: end;
      min-height: var(--ubilabs-input-height);
    }
  }

  .input {
    width: 100%;
  }
</style>

<div class="container {$$props.class}">
  <div>
    {#if label}
      <label for={id}>{label}{required ? '*' : ''}</label>
    {/if}
  </div>
  <div>
    <input
      class="input"
      type="number"
      name={id}
      {id}
      {step}
      {min}
      {max}
      {required}
      {placeholder}
      bind:value />
  </div>
</div>
